function Icon({ children }) {
	return(
		<svg
		viewBox="0 0 24 24"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		stroke="currentColor"
	>
		{children}
	</svg>
	)
}

export default Icon